<template>
  <Photo
    v-if="mediaType == 'photo'"
    class="view-media"/>
  <Video v-else
    class="view-media"/>
</template>

<script>
import Photo from '@/components/Media/Photo.vue';
import Video from '@/components/Media/Video.vue';
export default {
	name: "MediaView",
	components: {
    Photo,
    Video
  },
  computed: {
		mediaType() {
			return this.$store.state.toggle.mediaType
		}
  },
};
</script>
